import { useFetchInfiniteKolFootprintInfiniteQuery } from '@/api/workspace-api/directory-api'
import {
  FetchKolFootprintRequest,
  FetchKolFootprintResourceType,
} from '@/types/schema/directory/kol-management'

interface UseInitFetchKolFootprintProps {
  resourceTypeTotal: Record<FetchKolFootprintResourceType, number>
  isLoading: boolean
}

const useInitFetchKolFootprint = (
  kolId: string,
): UseInitFetchKolFootprintProps => {
  const options = {
    refetchOnMountOrArgChange: true,
  }

  const getRequest = (
    resourceType: FetchKolFootprintResourceType,
  ): FetchKolFootprintRequest => ({
    kolId,
    footprint_resource_type: resourceType === 'all' ? undefined : resourceType,
  })

  const { data: dataAll, isLoading: isLoadingAll } =
    useFetchInfiniteKolFootprintInfiniteQuery(getRequest('all'), options)
  const { data: dataCollectionFolder, isLoading: isLoadingCollectionFolder } =
    useFetchInfiniteKolFootprintInfiniteQuery(
      getRequest('collection-folder'),
      options,
    )
  const { data: dataCampaign, isLoading: isLoadingCampaign } =
    useFetchInfiniteKolFootprintInfiniteQuery(getRequest('campaign'), options)
  const { data: dataInsightReport, isLoading: isLoadingInsightReport } =
    useFetchInfiniteKolFootprintInfiniteQuery(
      getRequest('deep-report'),
      options,
    )
  const { data: dataOther, isLoading: isLoadingOther } =
    useFetchInfiniteKolFootprintInfiniteQuery(getRequest('other'), options)

  const isLoading =
    isLoadingAll ||
    isLoadingCollectionFolder ||
    isLoadingCampaign ||
    isLoadingInsightReport ||
    isLoadingOther

  return {
    resourceTypeTotal: {
      all: dataAll?.pages[0].data.total ?? 0,
      'collection-folder': dataCollectionFolder?.pages[0].data.total ?? 0,
      campaign: dataCampaign?.pages[0].data.total ?? 0,
      'deep-report': dataInsightReport?.pages[0].data.total ?? 0,
      other: dataOther?.pages[0].data.total ?? 0,
    },
    isLoading,
  }
}

export default useInitFetchKolFootprint
